<template>
  <app-base-main parentTable class="listing">
    <template #filter-group>
      <app-filter-group @reset="$gjReset" @query="$gjNoticeQuery">
        <gj-country-server-select v-model="filter.countryMarketValue"></gj-country-server-select>
        <gj-select
          v-model="filter.status"
          :options="listingStatus"
          placeholder="全部状态"
        ></gj-select>
        <gj-select
          v-model="filter.linkedStatus"
          :options="[
            { id: 'Linked', text: '已关联' },
            { id: 'NotLinked', text: '未关联' },
          ]"
          placeholder="关联状态"
        ></gj-select>
        <gj-select
          v-model="filter.fulfillment"
          placeholder="配送渠道"
          :options="shippingType"
          width="132px"
        ></gj-select>
        <gj-category-select
          v-model="filter.categoryIds"
          placeholder="品类"
          multiple
          active
        ></gj-category-select>
        <gj-charger-select
          v-model="filter.chargeIdList"
          collapse-tags
          placeholder="全部负责人"
          active
        >
        </gj-charger-select>
        <gj-select-input
          v-model="filter.keyword"
          :options="[
            { id: 'asin', text: 'ASIN', moreShow: true },
            { id: 'variationAsin', text: '父ASIN', moreShow: true },
            { id: 'msku', text: 'MSKU', moreShow: true },
            { id: 'sku', text: 'SKU' },
            { id: 'productName', text: '产品名称' },
            { id: 'title', text: '商品标题' },
          ]"
        ></gj-select-input>

        <template #advancedFilter>
          <gj-brand-select v-model="filter.brandId" placeholder="品牌" active></gj-brand-select>
          <gj-operation-state-select
            width="165px"
            placeholder="运营状态"
            v-model="filter.operationStatuses"
            multiple
          >
          </gj-operation-state-select>

          <gj-date-picker
            v-model="filter.date"
            type="daterange"
            tooltip="上架时间"
            :clearable="false"
          ></gj-date-picker>
        </template>
        <template #right>
          <view-setting
            :ref="REF_VIEW_SETTING"
            save-mode="remote"
            :use-default="true"
            :module-name="moduleName"
            :config="model"
            :fn-generate-params="generateViewParams"
            @view-change="handleChangeView"
            @view-complete="handCompleteView"
          >
          </view-setting>
        </template>
      </app-filter-group>
    </template>
    <template #operate-group>
      <template>
        <gj-dropdown placement="bottom-start" ref="linkproductbtn">
          <gj-button
            ><span>关联产品</span><i class="el-icon-arrow-down el-icon--right"></i
          ></gj-button>
          <template #dropdown>
            <gj-dropdown-item
              @click="batchRelateProduct"
              :disabled="noSelect"
              v-if="$permission('listing:linkProduct')"
              >批量关联</gj-dropdown-item
            >
            <gj-dropdown-item @click="importRelateProduct" v-if="$permission('listing:linkProduct')" 
                          :disabled="userGuideState"
              >导入关联产品</gj-dropdown-item
            >
            <gj-dropdown-item
              @click="batchUnlinkProduct"
              :disabled="noSelect || userGuideState"
              v-if="$permission('listing:linkProduct')"
              >批量解除关联</gj-dropdown-item
            >
          </template>
        </gj-dropdown>

        <gj-dropdown placement="bottom-start">
          <gj-button
            ><span>分配负责人</span><i class="el-icon-arrow-down el-icon--right"></i
          ></gj-button>
          <template #dropdown>
            <gj-dropdown-item
              v-if="$permission('listing:editDuty')"
              @click="importChargeDistribution"
              >导入分配负责人</gj-dropdown-item
            >
            <gj-dropdown-item
              :disabled="noSelect"
              v-if="$permission('listing:editDuty')"
              @click="handleBatchCharge"
              >批量分配负责人</gj-dropdown-item
            >
          </template>
        </gj-dropdown>
        <gj-button @click="synchroData" :disabled="noSelect">同步商品</gj-button>
        <gj-button
          @click="importOperation"
          :disabled="noSelect"
          v-if="$permission('listing:editOperationInfo')"
          >导入运营状态</gj-button
        >
        <gj-button
          @click="batchOffer"
          :disabled="noSelect"
          v-if="$permission('listing:adjustSalePrice')"
          >调价</gj-button
        >
        <gj-dropdown-button v-if="$permission('listing:printLabels')" :disabled="noSelect" placement="bottom-start">
          批量打印
          <template #dropdown>
            <gj-dropdown-item @click="printProductBar(selectedRows)">商品标签打印(模板)</gj-dropdown-item>
            <gj-dropdown-item @click="customPrint(selectedRows)">商品标签打印(自定义)</gj-dropdown-item>
          </template>
        </gj-dropdown-button>
        <gj-button v-if="$permission('listing:editFulfillment')" @click="changeFBMRepertory" :disabled="noSelect">修改FBM库存</gj-button>
      </template>
    </template>
    <template #tool-group>
      <gj-tool-group
        ref="toolGroup"
        :download="$permission('listing:export')"
        download-url="/operation/listing/export"
        :download-params="globalParams"
        help
        setting
        :sort-gjtable="$refs.gjTable ? $refs.gjTable.$children[0] : null"
        :table-name="whetherToShowFlagUi ? 'listing-tree-v1.8.0' : 'listing-arr-v1.8.0'"
        :table-columns="whetherToShowFlagUi ? columnsTree : columnsArr"
      >
        <template #before>
          <el-checkbox v-model="whetherToShowFlagUi" @change="$treeTabelHandel">
            展示变体关系
          </el-checkbox>
        </template>
      </gj-tool-group>
    </template>
    <template #table>
      <template v-if="!whetherToShowFlagUi">
        <app-listing-table
          ref="gjTable"
          adaptParent
          name="listing-arr-v1.8.0"
          :data="tableData"
          :filter="filter"
          :customData="columnsArr"
          :pagination="pagination"
          :loading="loading"
          selection
          :checkbox-config="{ labelField: 'mskuNum', highlight: true }"
          :size="'has-picture'"
          @sort-change="$gjSortChangeCatch"
          @page-change="$gjNoticeQuery"
          :default-sort="defaultSort"
          @updata-table="$gjNoticeQuery"
          @nextUserGuider="userGuideNextStep"
          @UserGuiderClose="userGuideCancel"
          @selection-change="checkBoxRow"
        >
        </app-listing-table>
      </template>
      <template v-else>
        <app-listing-tree-table
          ref="gjTable"
          adaptParent
          name="listing-tree-v1.8.0"
          :data="tableData"
          :filter="filter"
          :customData="columnsTree"
          :pagination="pagination"
          :loading="loading"
          selection
          :tree-config="{
            lazy: true,
            children: 'children',
            hasChild: 'hasChild',
            loadMethod: expandLazyLoad,
            transform: true,
            indent: 0
          }"
          :checkbox-config="{ labelField: 'mskuNum', highlight: true }"
          :size="'has-picture'"
          @sort-change="$gjSortChangeCatch"
          @page-change="$gjNoticeQuery"
          :default-sort="defaultSort"
          @updata-table="$gjNoticeQuery"
          @selection-change="checkBoxRow"
        >
        </app-listing-tree-table>
      </template>
    </template>
    <template v-if="(userGuideState && afterServiceData)" #base-content>
        <new-user-guide ref="newUserGuide" @closeModal="closeModal" :userGuideHighLightLeft="userGuideHighLightLeft"></new-user-guide>
      </template>
  </app-base-main>
</template>

<script>
import AppRelateProductModal from '@/views/layout/components/modal/relate-product-modal/relate-product-modal';
import AppProductOfferModal from './modal/product-offer-modal';
import AppInventoryChangeModal from './modal/inventory-change-modal';
import AppImportOperationModal from './modal/import-operation-modal';
import AppImportRelateProductModal from './modal/import-relate-product';
import AppLabelPrintModal from '@/views/components/label-print-modal/label-print-modal';
import ChargeDistributionModal from './modal/charge-distribution-modal';
import ImportChargeTemplateModal from './modal/import-charge-template-modal';
import AppListingTable from './components/listing-table'
import AppListingTreeTable from './components/listing-tree-table'
import { listingStatus, shippingType } from '@/utils/options';
import { isMeaningfulMixin, queryMixin, selectionMixin, userGuideMixin } from '@/minxins';
import { exportListing, syncListing, syncGetListingV2,getListItem, batchUnlinkProduct,} from '@/api/sale';
import { isMeaningful } from '@/utils/common';
import { convertToDate } from '@/utils/date.util';
import { mapGetters } from 'vuex';
import AppPrintListingLabelModal from './modal/print-listing-label-modal';
import { generateViewParams } from '@/utils/date.util';
import model from './viewConfig';
import { tagColors } from '@/components/tag/tag-colors';
import { columnsArr, columnsTree } from './helper';
import NewUserGuide from "./components/new-user-guide"

export default {
  name: 'app-listing',
  mixins: [queryMixin, selectionMixin, isMeaningfulMixin, userGuideMixin],
  components: { AppListingTable, AppListingTreeTable, NewUserGuide },
  computed: {
    ...mapGetters({
      marketOption: 'marketOption',
    })
  },
  created() {
    this.timeStamp = null;
    this.whetherToShowFlag = '';
  },
  data() {
    return {
      userGuideHighLightLeft:0,
      afterServiceData:false,
      defaultSort: { prop: '', order: '' },
      whetherToShowFlagUi: false,
      moduleName: 'LISTING',
      model,
      columnsArr,
      columnsTree,
      tableData: [],
      filter: {
        keyword: {
          key: 'asin',
          routeKey: null, // 记录router参数传入的key
          value: null,
          routeValue: null, // 记录router参数传入的value
          popover: false,
        },
        operationStatuses: [],
        chargeIdList: [],
        brandId: null,
        categoryIds: [],
        status: 'Active',
        linkedStatus: null,
        countryMarketValue: null,
        fulfillment: null,
        date: [],
      },
      listingStatus,
      shippingType,
      cacheOptions: {
        useCache: true,
      },
      needShowHighlight : true
    };
  },
  methods: {
    checkBoxRow(rows) {
      this.selectedRows = rows;
    },
    getRowParams(rows) {
      let ids = [];
      rows.forEach((item) => {
        if (item.isVariant) {
          ids = ids.concat(item.ids);
        } else {
          ids.push(item.id);
        }
      });
      return ids;
    },
    // 关联产品
    batchUnlinkProduct(row) {
      const vm = this;
      let ids = row ? [row.id] : this.getRowParams(vm.selectedRows);
      if (ids.length >= 50) {
        this.$gjMessage.warning('一次最多操作50条数据');
        return;
      }
      const modal = this.$gjCreate('gj-info-modal', {
        props: {
          content: '您确定要解除该系列商品的关联关系吗?',
        },
        on: {
          cancel() {
            modal.$gjDestroy();
          },
          confirm() {
            modal.confirmLoading = true;
            batchUnlinkProduct({ ids })
              .then(() => {
                vm.$gjMessage.success('操作成功');
                vm.$gjResetPage();
                modal.$gjDestroy();
              })
              .complete(() => modal.confirmLoading);
          },
        },
      });
    },

    closeModal() {
        if(this.adAuthModal)  {
          this.isAutoAdAuthModal = true; // 是否为主动销毁
          this.adAuthModal.$gjDestroy();
          this.adAuthModal = null;
        }
     },
    // 修改库存
    changeFBMRepertory() {
      const vm = this;
      const modal = this.$gjCreate(AppInventoryChangeModal, {
        props: {
          rows: this.selectedRows,
        },
        on: {
          after() {
            vm.$gjResetPage();
            modal.$gjDestroy();
          },
        },
      });
    },
    // 树装变化
    $treeTabelHandel() {
      this.whetherToShowFlag = this.whetherToShowFlagUi;
      this.tableName = this.whetherToShowFlag ? 'listing-tree-v1.8.0' : 'listing-arr-v1.8.0';
      this.$gjNoticeQuery();
    },
    // 展开子集
    expandLazyLoad({ row }) {
      let params = {
        ...this.filter,
        openStartDate: convertToDate(this.filter.date[0]),
        openEndDate: convertToDate(this.filter.date[1]),
        variationAsin: row.asin,
        marketIds: [row.marketId],
      };
      if (this.filter.keyword.value) {
        params[this.filter.keyword.key] = this.filter.keyword.value;
      } else {
        params.msku = row.msku;
      }
      return getListItem(params).then((data) => {
        let childList = this.handelListData(data, 'child');
        return Promise.resolve(childList);
      });
    },
    getColor(status) {
      switch (status) {
        case '在售':
          return tagColors.greenText;
        case '停售':
          return tagColors.gray9Text;
        case '不完整':
          return tagColors.orangeText;
        case '删除':
          return tagColors.gray6Text;
      }
    },
    /**
     *
     * @param params 查询条件参数
     * @override queryMixin
     * @returns {{countryMarketValue: *}}
     */
    // $gjCacheCallback() {
    //   return {
    //     countryMarketValue: this.filter.countryMarketValue,
    //   };
    // },
    $gjQuery() {
      this.loading = true;
      if(this.userGuideState){
        this.needShowHighlight = true
        this.filter.status = null
        this.filter.linkedStatus = 'NotLinked'
        this.whetherToShowFlagUi = false
        this.whetherToShowFlag = false
        if(this.$refs['newUserGuide']){
          if(this.$refs['newUserGuide'].bootSteps == 2) {
            this.filter.linkedStatus = 'Linked'
          }

          if(this.$refs['newUserGuide'].bootSteps >= 2) {
            this.needShowHighlight = false
          }
        }
      }
      let params = {
        model: {
          ...this.filter,
          openStartDate: convertToDate(this.filter.date[0]),
          openEndDate: convertToDate(this.filter.date[1]),
        },
        ...this.queryPagination,
        ...this.querySort,
      };
      if (this.whetherToShowFlag !== '') {
        params.model.whetherToShowFlag = this.whetherToShowFlag;
      }
      // params.model.linkedStatus = 'Linked'
      params.model[this.filter.keyword.key] = this.filter.keyword.value;
      if (isMeaningful(this.filter.countryMarketValue)) {
        params.model.marketIds = this.filter.countryMarketValue.marketIds;
        params.model.countryCodes = this.filter.countryMarketValue.countryIds;
      }
      this.globalParams = params;
      syncGetListingV2(params)
        .then((data) => {
          if (data.orders.length) {
            this.defaultSort.prop = data.orders[0].column;
            this.defaultSort.order = data.orders[0].asc ? 'ascending' : 'descending';
          }
          if (this.whetherToShowFlag === '') {
            this.whetherToShowFlagUi = data.records.length
              ? data.records[0].whetherToShowFlag
              : false;
            this.$nextTick(() => {
              this.tableData = this.handelListData(data.records || []);
              this.pagination = this.getPagination(data);
            })
          } else {
            this.tableData = this.handelListData(data.records || []);
            this.pagination = this.getPagination(data);
          }
        })
        .complete(() => {
          this.loading = false;
          if(this.userGuideState) {
            this.afterServiceData = true
            setTimeout(() => {
            // this.$refs.gjTable.$children[0].$refs.gjTable.toggleCheckboxRow(this.tableData[0])
              this.selectedRows.push(this.tableData[0])
              if(this.needShowHighlight){
                let btn = document.getElementById("dropdown")
                if (btn) {
                  btn.click()
                }
                let iconBtn = document.getElementById("skuicon")
                if(iconBtn){
                  this.userGuideHighLightLeft = iconBtn.getBoundingClientRect().left
                }
                this.$refs.linkproductbtn.$children[0].visible = true

              }
            }, 300)
          }
        });
    },
    // 处理返回结果
    handelListData(arr, type = 'parent') {
      arr.forEach((r, index) => {
        r.saleDate = [r.saleStartDate || '', r.saleEndDate || ''];
        r.hasChild = Boolean(r.isVariant);
        r.mskuNum = r.isVariant ? r.mskuNum : '子体';
        r.yesterdaySales = r.yesterdaySales ? `${r.currencySymbol}${r.yesterdaySales}` : '';
        r.yesterdayAdsSpend = r.yesterdayAdsSpend
          ? `${r.currencySymbol}${r.yesterdayAdsSpend}`
          : '';
        r.star = +r.star;
        r.myIndex = index + 1;
        r.statusColor = this.getColor(r.status);
        if(type === 'child') {
          r.isTreeChild = true
        }
      });
      return arr
    },
    // 每次新打开页面时，初始化页面参数
    // 若路由中传入了查询参数timeStamp，则填入，并记录
    $gjQueryInitParams() {
      let filter = {
        filter: {
          keyword: {
            key:
              this.$route.query.timeStamp !== this.timeStamp
                ? this.$route.query.routeKey
                : 'asin',
            value:
              this.$route.query.timeStamp !== this.timeStamp
                ? this.$route.query.routeValue
                : null,
            popover: false,
          },
          operationStatuses: [],
          chargeIdList: [],
          brandId: null,
          categoryIds: [],
          status: 'Active',
          linkedStatus: null,
          countryMarketValue:
            this.$route.query.timeStamp && this.$route.query.timeStamp !== this.timeStamp
              ? {
                  countryIds: this.$route.query.countryIds.split(','),
                  marketIds: this.$route.query.marketIds.split(','),
                }
              : {},
          date: [],
          fulfillment: null,
        },
      };
      this.timeStamp = this.$route.query.timeStamp
      return filter
    },
    printProductBar(rows) {
      let ids = this.getRowParams(rows);
      if (ids.length > 50) {
        this.$gjMessage.error('一次最多操作50条数据');
        return;
      }
      this.$gjCreate(AppPrintListingLabelModal, {
        props: {
          items: rows,
          ids: ids,
          isFasin: this.whetherToShowFlagUi
        },
      });
    },
    customPrint(rows) {
      let ids = this.getRowParams(rows);
      if (ids.length > 50) {
        this.$gjMessage.error('一次最多操作50条数据');
        return;
      }
      this.$gjCreate(AppLabelPrintModal, {
        props: {
          source: 'listing',
          mode: this.whetherToShowFlagUi?'interface':'direct',
          params: {
            listingIds: ids,
            printBizType: 'listing'
          },
          items: rows,
          columns: [
            {id: 'picture', header: '图片', field: 'picture:imageUrl', minWidth: '60px'},
            {id: 'asin', header: 'ASIN/MSKU', field: 'slot:asin', minWidth: '120px'},
            {id: 'fnsku', header: 'FNSKU', field: 'slot:fnsku', minWidth: '100px'},
            {id: 'title', header: '商品标题', field: 'slot:title', minWidth: '130px' },
            {id: 'titlePrint', header: '商品标题(打印)', field: 'slot:titlePrint', minWidth: '140px'},
            {id: 'productName', header: '产品名称/SKU', field: 'slot:productName', minWidth: '120px'},
            {id: 'marketId', header: '店铺/国家', field: 'option:marketId', minWidth: '80px', default: true, options: () => this.marketOption,},
            {id: 'printCount', header: 'slot:printCount', field: 'slot:printCount', align: 'left', width: '140px'},
            {id: 'op', header: '操作', field: 'slot:op', minWidth: '80px', fixed: 'right', notCustomColumn: true, }
          ]
        },
      });
    },
    // 批量处理数据
    batchRelateProduct(row) {
      const vm = this;
      let ids = row ? [row.id] : this.getRowParams(vm.selectedRows);
      if (ids.length >= 50) {
        this.$gjMessage.warning('一次最多操作50条数据');
        return;
      }
      this.userGuideNextStep()
      this.adAuthModal = this.$gjCreate(AppRelateProductModal, {
        props: {
          msku:vm.selectedRows.length ? vm.selectedRows[0].msku : '',
          ids,
          mode: 'batch',
        },
        on: {
          after() {
            vm.$gjResetPage();
            this.adAuthModal.$gjDestroy();
            vm.isAutoAdAuthModal = true
            this.userGuideNextStep()


          },
          close: () => {
              if(!vm.isAutoAdAuthModal) {
                vm.userGuideCancel()
                vm.isAutoAdAuthModal = false
              }
            },
          userGuide: () => {
            // 引导用户
            this.userGuideNextStep()

          },
        },
      });
    },
    relateProduct(item) {
      const vm = this;
      const modal = this.$gjCreate(AppRelateProductModal, {
        props: {
          id: item.id,
          mode: 'single',
          msku: item.msku,
        },
        on: {
          after() {
            vm.$gjResetPage();
            modal.$gjDestroy();
          },
        },
      });
    },
    // 同步数据
    synchroData() {
      if (this.selectedRows.length > 20) {
        this.$gjMessage.error('最多支持一次性同步20个商品!');
        return;
      }
      syncListing({ ids: this.selectedRows.map((item) => item.id) }).then((data) => {
        this.$gjMessage.info('正在进行同步，操作日志查看结果');
      });
    },
    batchOffer() {
      const vm = this;
      const modal = this.$gjCreate(AppProductOfferModal, {
        props: {
          rows: this.selectedRows,
        },
        on: {
          after() {
            vm.$gjResetPage();
            modal.$gjDestroy();
          },
        },
      });
    },
    clickDownload() {
      exportListing(this.globalParams);
    },
    // 导入
    importOperation() {
      const modal = this.$gjCreate(AppImportOperationModal, {
        on: {
          importFileSuccess: () => {
            this.$gjResetPage();
          },
          importSuccess: () => {
            modal.$gjDestroy();
          },
        },
      });
    },
    importRelateProduct() {
      const modal = this.$gjCreate(AppImportRelateProductModal, {
        on: {
          importFileSuccess: () => {
            this.$gjResetPage();
          },
          importSuccess: () => {
            modal.$gjDestroy();
          },
        },
      });
    },
    /**
     * 批量分配负责人
     */
    handleBatchCharge() {
      this.openChargeDistributionModal();
    },
    /**
     * 分配负责人弹窗
     * @param id
     */
    openChargeDistributionModal(row) {
      let vm = this;
      let ids = row ? [row.id] : this.getRowParams(vm.selectedRows);
      if (ids.length >= 50) {
        this.$gjMessage.warning('一次最多操作50条数据');
        return;
      }
      const modal = this.$gjCreate(ChargeDistributionModal, {
        props: {
          ids,
        },
        on: {
          confirm: () => {
            this.$gjResetPage();
            modal.$gjDestroy();
          },
        },
      });
    },
    /**
     * 导入分配负责人
     */
    importChargeDistribution() {
      const modal = this.$gjCreate(ImportChargeTemplateModal, {
        on: {
          importFileSuccess: () => {
            this.$gjResetPage();
          },
          importSuccess: () => {
            modal.$gjDestroy();
            this.$gjResetPage();
          },
        },
      });
    },
    generateViewParams,
    mergeRemoteParams(params) {
      const date = params.date
        ? params.date
        : params.startDateTime && params.endDateTime
        ? [params.startDateTime, params.endDateTime]
        : this.filter.date;
      this.filter = Object.assign({}, this.filter, {
        ...params,
        date,
      });
    },
    loadViewComplete() {},
  },
};
</script>

